(function () {
	angular
		.module('trackeye')
		.directive('openlayers', OpenLayersDirective);

	OpenLayersDirective.$inject = ['OpenLayersService'];

	function OpenLayersDirective(OpenLayersService) {
		return {
			restrict: "E",  // Element directive
			link: function (scope, element, attributes) {
				OpenLayersService.initialize(element);

				scope.$on('angular-resizable.resizing', function () {
					OpenLayersService.updateSize();
				});
			}
		};
	}
})();